import { render } from "./Singers.vue?vue&type=template&id=58cda424"
import script from "./Singers.vue?vue&type=script&lang=js"
export * from "./Singers.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__